/*
 * @Description: 登录相关Api
 * @Author:
 * @Date: 2022-09-21 22:26:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-03 17:40:53
 * @FilePath: \VUE3\src\api\login.js
 */
import request from './request'

// 获取token
export function getCurrentUserZw (data) {
  return request({
    url: '/api/v2/account/getCurrentUserZw',
    method: 'post',
    data
  })
}
/**
 * 所有菜单
 * @param {*} data
 * @returns
 * 菜单类别(cdlb: 1)：1-教学应用服务，2-决策支持应用服务， 3-管理应用服务， 4-文化生活应用服务，5-科研应用服务， 6-公共服务，7-社会服务
 */
export function menuTree (data) {
  return request({
    url: '/api/v2/sys/menu/denglurentree',
    method: 'POST',
    data
  })
}

/**
 * 获取权限列表
 * @param {jzgid: 用户ID} query
 * @returns
 */
export function findUserRoleList (query) {
  return request({
    url: '/api/v2/xiaoneigangwei/selectByJgOrZwOrJzg',
    method: 'POST',
    params: query
  })
}

// 退出
export function postAccessLogout (data) {
  return request({
    url: '/api/v2/account/logout',
    method: 'POST',
    data
  })
}
// 获取用户信息
export function getCurrentUser (data) {
  return request({
    url: '/api/v2/account/getCurrentUserXm',
    method: 'POST',
    data
  })
}
// 消息
export function findxiaoxiList (query) {
  return request({
    url: '/api/v2/bangong/xitongxiaoxi/list',
    method: 'POST',
    params: query
  })
}
// 消息详情
export function getxiaoxiInfo (query) {
  return request({
    url: '/api/v2/bangong/xitongxiaoxi/' + query.id,
    method: 'POST'
  })
}
// 修改密码
export function mimaEdit (data) {
  return request({
    url: '/api/v2/pdp/jiaozhigong/password',
    method: 'PATCH',
    data
  })
}
